export const chargerDetailsInputDebounce = 300;
export const EDGE_DEMO_URL_FLAG = 'edgeDemo';

export const EDGE_CONTROLLER_TABS = [
  { label: 'Details', value: 'details' },
  { label: 'Plaza', value: 'plaza' },
  { label: 'Components', value: 'components' },
  { label: 'Activities', value: 'activities' },
];

export const EDGE_CONTROLLER_ALL_TABS = [
  { label: 'Details', value: 'details' },
  { label: 'Activities', value: 'activities' },
  { label: 'Components', value: 'components' },
  { label: 'Configuration', value: 'configuration' },
  { label: 'Plaza', value: 'plaza' },
  { label: 'Monitoring', value: 'monitoring' },
];

export const FORMAT_FOR_API = 'MM/DD/YYYY';
